import start from './src/start';
import glightbox from '../globali/glightbox';

start();
glightbox();
